import { atom, selector } from 'recoil'

import {
  isValidEmail,
  isValidMobileNumber,
  isValidMobilePrefix,
} from 'Helpers/validators'

import type { PanelEditContactsState } from 'Pages/RecipientsList/model'

export const panelEditContactsState = atom<PanelEditContactsState>({
  key: 'panelEditContactsState',
  default: {
    show: false,
    idRecipient: 0,
    EmailDisabled: false,
    EmailRequired: false,
    SMSDisabled: false,
    SMSRequired: false,
    Email: '',
    MobilePrefix: '',
    MobileNumber: '',
    isDirty: false,
  },
})

export const panelEditContactsIsEmailValidState = selector<boolean>({
  key: 'recipientsList_panelEditContactsIsEmailValidState',
  get: ({ get }) => {
    const { Email, EmailDisabled, EmailRequired } = get(panelEditContactsState)

    return (
      EmailDisabled ||
      (!EmailRequired && Email.length === 0) ||
      isValidEmail(Email)
    )
  },
})

export const panelEditContactsIsMobileValidState = selector<boolean>({
  key: 'recipientsList_panelEditContactsIsMobileValidState',
  get: ({ get }) => {
    const { MobilePrefix, MobileNumber, SMSDisabled, SMSRequired } = get(
      panelEditContactsState,
    )

    const mobile = `${MobilePrefix}${MobileNumber}`

    return (
      SMSDisabled ||
      (!SMSRequired && mobile.length === 0) ||
      (isValidMobilePrefix(MobilePrefix) && isValidMobileNumber(MobileNumber))
    )
  },
})

export const panelEditContactsCanSaveState = selector<boolean>({
  key: 'recipientsList_panelEditContactsCanSaveState',
  get: ({ get }) => {
    const validEmail = get(panelEditContactsIsEmailValidState)
    const validMobile = get(panelEditContactsIsMobileValidState)

    return validEmail && validMobile
  },
})
